import { usuario } from "./usuario";
import { criterio } from "./criterio";
import { grupoConceito } from "./grupoConceito";
import { modeloQuestao } from "./modeloQuestao";

export const configuracao = [
  ...usuario,
  ...criterio,
  ...grupoConceito,
  ...modeloQuestao
];



// WEBPACK FOOTER //
// ./src/routes/prova/configuracao/index.js